import { CircularProgress } from '@mui/material';

function Spinner ({size, color}) {
    return <CircularProgress sx={{color: color || "#F9D857"}} size={size || 70}/>
}

export default Spinner
